import dynamic from "next/dynamic";

export const UsefulLinks = dynamic(() => import("./component"));
